module.exports = __webpack_public_path__ + "static/media/028.cd2a6a2b.jpg";